import styled from "styled-components";

export type SkeletonComponentProps = {
  width?: number;
  height?: number;
  shape: "circle" | "rectangle" | "rounded";
};

const Skeleton = styled.div<{
  style: { width?: number; height?: number };
  shape: "circle" | "rectangle" | "rounded";
}>`
  background-color: rgba(0, 0, 0, 0.11);
  overflow: hidden;
  width: ${({ style }) => style.width + "px" || "auto"};
  height: ${({ style }) => style.height + "px" || "auto"};
  border-radius: ${({ shape }) =>
    shape === "circle" ? "50%" : shape === "rounded" ? "5px" : "0"};

  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.08), transparent);
    animation: skeletonanimation 2s ease-in-out 0.5s infinite;
    transform: translateX(-100%);
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  @keyframes skeletonanimation {
    0% {
    transform: translateX(-100%);
  }
  50% {
      transform: translateX(100%);
  }
  100% {
      transform: translateX(100%);
    }
`;

export const SkeletonComponent: React.FC<SkeletonComponentProps> = ({
  width,
  height,
  shape,
}) => {
  return <Skeleton style={{ width, height }} shape={shape} />;
};

export default SkeletonComponent;
